module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/create.js
// module id = 118
// module chunks = 35783957827783 114276838955818 162898551421021